import React from "react";
import PropTypes from "prop-types";
import { HardCodedComponent } from "../../components/HardCodedComponent";

const HardCodedComponentConnector = ({ data = {} }) => (
	<HardCodedComponent
		id={data.id}
		markup={data.markup?.markup}
		javaScriptFiles={data.javaScriptFiles}
		cssFiles={data?.cssFiles}
		javaScriptContainer={data.javaScriptContainer?.childMarkdownRemark?.rawMarkdownBody}
		onFileLoad={data.onFileLoad}
		cssContainer={data.cssContainer?.childMarkdownRemark?.rawMarkdownBody}
		cleanupScript={data.cleanupScript?.childMarkdownRemark?.rawMarkdownBody}
	/>
);

HardCodedComponentConnector.propTypes = {
	data: PropTypes.shape({
		id: PropTypes.string,
		markup: PropTypes.shape({
			markup: PropTypes.string,
		}),
		javaScriptFiles: PropTypes.arrayOf(PropTypes.string),
		cssFiles: PropTypes.arrayOf(PropTypes.string),
		javaScriptContainer: PropTypes.shape({
			childMarkdownRemark: PropTypes.shape({
				rawMarkdownBody: PropTypes.string,
			}),
		}),
		onFileLoad: PropTypes.bool,
		cssContainer: PropTypes.shape({
			childMarkdownRemark: PropTypes.shape({
				rawMarkdownBody: PropTypes.string,
			}),
		}),
		cleanupScript: PropTypes.shape({
			childMarkdownRemark: PropTypes.shape({
				rawMarkdownBody: PropTypes.string,
			}),
		}),
	}).isRequired,
};

export { HardCodedComponentConnector };
